import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { StatoFinanziamento } from '../models';


class DataTablesResponse {
    data: StatoFinanziamento[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class StatoFinanziamentoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}StatiFinanziamento/`;
    constructor(private http: HttpClient) { }

    getAll(){
        return this.http.get<StatoFinanziamento[]>(
            `${this.apiUrl}`            
        );
    }
    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    insert(s: StatoFinanziamento) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: StatoFinanziamento) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:StatoFinanziamento){
        if(s.id)return this.update(s);
        return this.insert(s);
    }

}
